import { render, staticRenderFns } from "./publicClassDetail.vue?vue&type=template&id=8abde88c&scoped=true"
import script from "./publicClassDetail.vue?vue&type=script&lang=js"
export * from "./publicClassDetail.vue?vue&type=script&lang=js"
import style0 from "./publicClassDetail.vue?vue&type=style&index=0&id=8abde88c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8abde88c",
  null
  
)

export default component.exports